/*
*
* File JS componente Block Slider Off Screen
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';

require ('lightgallery.js');
import 'lightgallery.js/dist/css/lightgallery.min.css';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-slider-off-screen.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockSliderOffScreen = () => {

    let sliderAll = document.querySelectorAll('.block-slider-off-screen .swiper-container');

    if(!sliderAll) return;

    sliderAll.forEach(el => {

        let arrowPrev = el.querySelector('.swiper-button-prev');
        let arrowNext = el.querySelector('.swiper-button-next');

        let pagination = el.querySelector('.swiper-pagination');

        let typePagination = 'progressbar';

        let args = {
            slidesPerView: 'auto',
            spaceBetween: 20,
            navigation: 
            {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            pagination:
            {
                el: pagination,
                type: typePagination,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                },
                768: {
                    slidesPerView: 2,
                }
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        };

        new Swiper(el, args);

        let thisGallery = el.querySelector('.lightgallery');

        if(!thisGallery) return;

        lightGallery(thisGallery, {
            thumbnail: false,
            animateThumb: false,
            showThumbByDefault: false,
            download: false,
            hideBarsDelay: 1000000000,
            closable: false,
            zoom: false,
            fullScreen: false,
            autoplayControls: false,
            counter: false,
            hash: false,
            escKey: true,
            keyPress: true
        });
    })
}

export default blockSliderOffScreen;

//--------------------------------------------------------------------//